const { localiseUrl } = require('./format-localised-url');
const { findKeyBy } = require('../config/product');
const DocumentUID = require('../models/prismic/base/DocumentUID');
const qs = require('qs');

/**
 * getUrlByUid - Find the correct path by Prismic UID
 * @param {String} uid - A Prismic UID
 * @param {Boolean} withLocalisedUrl - Localise the return url
 * @returns {String} Return url either localised or not.
 */
const getUrlByUid = (uid = '', withLocalisedUrl = true, queryParams = {}) => {
  const document = new DocumentUID(uid);
  const pageType = document.getPageType();
  const country = document.getCountry();
  const slug = document.getSlug();
  let path = '/';

  switch (pageType) {
    case 'homepage-variant':
      path = `/landing-pages/${slug}`;
      break;
    case 'range-variant':
      path = `/landing-pages/personalized-products/${slug}`;
      break;
    case 'product-variant':
      path = `/landing-pages/personalized-products/product/${slug}`;
      break;
    case 'offers-variant':
      path = `/offers/${slug}`;
      break;
    case 'product':
      path = `/personalized-products/${slug}`;
      break;
    case 'canvas':
      path = `/personalized-products/${slug}/preview`;
      break;
    case 'options':
      path = `/personalized-products/${slug}/options`;
      break;
    case 'product-range':
      path = `/personalized-products`;
      break;
    case 'pages':
      path = `/pages/${slug}`;
      break;
    case 'cart':
      path = '/cart';
      break;
    case 'cart-variant': {
      queryParams.contentVariant = slug;
      path = `/cart`;
      break;
    }
    case 'orders':
      path = '/orders';
      break;
    case 'account':
      path = '/account';
      break;
    default:
      const productKey = findKeyBy.sku(pageType);
      if (productKey) {
        path = `/personalized-products/${slug}`;
      }
  }

  const query = qs.stringify(queryParams, { addQueryPrefix: true });

  path = `${path}${query}`;

  // Return the correct path but localised to the locale set in the UID
  if (withLocalisedUrl) {
    return localiseUrl(country, path);
  }
  return path;
};

module.exports = getUrlByUid;



// WEBPACK FOOTER //
// ./src/common/utils/get-url-by-uid.js